<template>
  <div class="wrap">
    <div>
      <div class="detailsTop">
        <van-nav-bar title="订单详情" left-arrow @click-left="onClickLeft" />
      </div>
      <!-- 地址 -->
      <div
        style="
          width: 94%;
          margin-left: 3%;
          padding: 10px 0;
          border-radius: 10px;
          background: white;
          margin-top: 10px;
        "
      >
        <div class="order-item-wrapper">
          <div class="order-header">
            <div style="color: #ff9600">
              订单号:{{ orderDetails.order_num }}
            </div>
            <div
              class="orderStatus"
              v-show="
                orderDetails.status == 1 ||
                orderDetails.status == 2 ||
                orderDetails.status == 3
              "
            >
              进行中
            </div>
            <div class="orderStatus" v-show="orderDetails.status == 4">
              已发货
            </div>
            <div class="orderStatus" v-show="orderDetails.status == 5">
              已取消
            </div>
          </div>
          <div class="order-body">
            <div class="order-body-pic">
              <img :src="orderDetails.goods.image" alt class="goodsImg" />
            </div>
            <div class="order-body-info">
              <div style="margin: 8px 0">
                <div>{{ orderDetails.goods.name }}</div>
                <div></div>
              </div>
              <div class="order-body-info-name">
                <div style="color: #fe881e">￥{{ orderDetails.price }}</div>
                <div>*{{ orderDetails.nums }}</div>
              </div>
              <div class="order-body-info-num">
                <div>快递:{{ orderDetails.freight }}</div>
                <div>小计:￥{{ orderDetails.total_price }}</div>
              </div>
            </div>
          </div>
        </div>
        <van-cell title="订单信息" />
        <div style="padding: 7px 28px; font-size: 13px; color: #999999">
          订单备注：
          <span style="color: #333333">{{ orderDetails.remarks }}</span>
        </div>
                  <div style="padding: 7px 28px; font-size: 13px; color: #999999">
          收货人姓名：
          <span style="color: #333333">{{ orderDetails.name }}</span>
        </div>
        <div style="padding: 7px 28px; font-size: 13px; color: #999999">
          收货地址：
          <span style="color: #333333"
            >{{ orderDetails.address }} {{ orderDetails.detail }}</span
          >
        </div>

        <div style="padding: 7px 28px; font-size: 13px; color: #999999">
          联系电话：
          <span style="color: #333333">{{ orderDetails.phone }}</span>
        </div>
        <div style="padding: 7px 28px; font-size: 13px; color: #999999">
          物流公司：
          <span style="color: #333333">{{ orderDetails.logistics_name }}</span>
        </div>
        <div style="padding: 7px 28px; font-size: 13px; color: #999999">
          物流编号：
          <span style="color: #333333">{{
            orderDetails.logistics_number
          }}</span>
        </div>
        <div
          style="
            padding: 7px 28px;
            font-size: 13px;
            color: #999999;
            border-bottom: 1px solid #e5e5e5;
          "
        >
          下单时间：
          <span style="color: #333333">{{ orderDetails.create_time }}</span>
        </div>
        <!-- <van-cell title="付款时间" class="vanceel" :value="orderDetails.pay_time">
        </van-cell>
        <van-cell title="发货时间" v-show="orderDetails.status>1" class="vanceel" :value="orderDetails.logistics_time">
        </van-cell> -->
        <div style="padding: 7px 28px; font-size: 13px; color: #999999">
          付款时间：
          <span style="color: #333333">{{ orderDetails.pay_time }}</span>
        </div>
        <div style="padding: 7px 28px; font-size: 13px; color: #999999">
          发货时间：
          <span style="color: #333333">{{ orderDetails.logistics_time }}</span>
        </div>
      </div>
      <!--      <van-cell title="付款凭证" class="vanceel">
        <van-uploader :after-read="upProof">
          <img :src="orderDetails.voucher" alt v-if="orderDetails.voucher" class="upImg" />
          <img src="../../assets/imgs/personal/upImg.png" v-else alt class="upImg" />
        </van-uploader>
      </van-cell> -->
      <!-- <van-button round block color="#FA4A42" v-if="orderDetails.status==3"
        @click="$router.push({path:'goodsEva',query:{id:goods_id}})">去评价</van-button> -->
      <!-- <van-button round block color="#3B6BFB" @click="submitOrder" v-if="orderDetails.status==2">确认收货</van-button> -->
    </div>
  </div>
</template>
<script>
import { orderDetail, sureOrders, orderVoucher } from "@/api/personal";
import { fileUpload } from "@/api/personal";
import { Dialog } from "vant";
export default {
  data() {
    return {
      dialog: false,
      orderDetails: {},
      shopuser: [],
    };
  },
  created() {
    this.goods_id = this.$route.query.id;
    orderDetail(this.goods_id).then((res) => {
      this.orderDetails = res;
    });
  },

  methods: {
    upProof(file) {
      let formData = new FormData();
      formData.append("image", file.file);
      fileUpload(formData).then((res) => {
        this.orderDetails.voucher = res.path;
      });
    },
    submitProof() {
      orderVoucher({
        ids: this.orderDetails.id,
      }).then((res) => {
        setTimeout(() => {
          this.$router.push({
            path: "myOrder",
            query: { active: 2, status: 1 },
          });
        }, 200);
      });
    },
    submitOrder() {
      Dialog.confirm({
        title: "确定",
        message: "是否确定已经收到货物",
      })
        .then(() => {
          sureOrders({ id: this.orderDetails.id }).then((res) => {
            this.$router.push({
              path: "myOrder",
              query: { active: 3, status: 3 },
            });
          });
        })
        .catch(() => {});
    },
    onClickLeft() {
      let active = "";
      let status = this.orderDetails.status;
      if (status == 1 || status == 2 || status == 3) {
        active = 0;
      } else if ((status = 4)) {
        active = 1;
      } else {
        active = 2;
      }
      this.$router.push({
        path: "myOrder",
        query: { typeActive: 0, active: active, status: status },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.vanceel {
  padding: 4px 28px;
  background: transparent;
  margin-top: 10px;
}

.upImg {
  width: 86px;
  height: 86px;
}

.van-cell::after {
  border: none;
}

.mark {
  width: 100%;
  height: 100%;
  z-index: 99;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
  }
}

.van-stepper {
  text-align: right;
}

.van-card {
  background: white;
  border-bottom: 1px solid #e5e5e5;
}

.van-submit-bar__text {
  text-align: left;
}

.van-button--warning {
  background: none;
  color: #ff6a19;
  border: 1px solid #ff6a19;
  width: 110px;
  height: 40px;
  font-size: 13px;
}

.van-submit-bar__price {
  color: #ff6a19;
}

.wrap {
  width: 100%;
  height: 100vh;
  background: #f5f4f7;
  padding-bottom: 60px;
}

[class*="van-hairline"]::after {
  border: 0 none;
}

.detailsTop {
  width: 100%;
}

.address-container {
  background: white;
  padding: 13px 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  box-shadow: 0 0 3px 1px #eee;
  box-sizing: border-box;

  .location-img {
    width: 36px;
    height: 36px;
    margin-right: 10px;
  }

  .address-info {
    width: 247px;
    line-height: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 12px;

    .address-info-top {
      > span:first-child {
        margin-right: 20px;
      }

      > span:last-child {
        color: #a8a8a8;
      }
    }
  }

  .no-default-address {
    font-size: 12px;
    color: #a8a8a8;
    width: 267px;
  }

  .arrow-icon {
    font-size: 16px;
  }

  .content {
    display: inline-block;
    vertical-align: top;
    margin-top: 9px;
    font-size: 16px;

    p {
      margin: 0;
      font-size: 15px;
      line-height: 8px;

      span {
        color: #999999;
      }
    }

    > span {
      font-size: 12px;
      line-height: 45px;
    }
  }
}

.midItem {
  margin-top: 12px;
  margin-bottom: 14px;
  font-size: 11px;
  color: #666;

  .midNum {
    color: #bb5b5c;
  }
}

.orderInfo {
  margin: 0 auto;
  background: #fff;
  box-sizing: border-box;
  width: 345px;
  border-radius: 10px;
  height: 153px;
  box-shadow: 0 0 6px 1px #f5f5f5;
  color: #333;
  font-size: 14px;

  .infoTitle {
    padding: 16px 20px 12px 15px;
    font-size: 14px;

    .orderStatus {
      color: #fe9820;
    }
  }

  .infoCon {
    padding: 0 0 16px 15px;
  }
}

.order-item-wrapper {
  border-radius: 8px;
  background-color: #fff;
  font-size: 12px;
  margin: 0 auto;

  .order-header {
    height: 35px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0px 16.5px;
    font-size: 14px;
    width: 100%;

    .orderStatus {
      color: #ff9600;
    }
  }

  .order-body {
    box-sizing: border-box;
    display: flex;
    padding: 5px 12.5px 8px 12px;
    border-bottom: 1px solid #e5e5e5;

    &-pic {
      width: 100px;
      height: 100px;
      margin-right: 11.5px;
      background-color: #f5f5f5;

      img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
      }
    }

    &-info {
      width: 75%;

      &-name {
        display: flex;
        width: 100%;
        justify-content: space-between;

        div:first-child {
          height: 24px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }

      &-num {
        display: block;
        display: flex;
        width: 100%;
        justify-content: space-between;
        font-size: 12px;
        margin-top: 12px;
      }
    }
  }

  .order-bottom {
    display: flex;
    flex-direction: row-reverse;
    padding: 8px 12px;

    &-ctr {
      .itemNum {
        color: #333;
        font-size: 12px;
      }

      .itemPrice {
        span:last-child {
          color: #de4f53;
          font-size: 18px;
        }
      }
    }
  }
}

.popBtn {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  height: 52.5px;
  z-index: 1000;
  // padding-top: 14px;
  box-sizing: border-box;

  .van-button {
    height: 27px;
    border: 0 none;
    font-size: 14px;
    width: 94.5px;
    color: #fff;
    line-height: 27px;
    padding: 0;
    border-radius: 13.5px;
  }

  .carBtn {
    background: #1e854c;
    margin-right: 2.5px;
  }

  .buyBtn {
    background: linear-gradient(to right, #ff6e02, #ffcc33);
    margin-right: 25px;
  }
}

/deep/ .van-stepper__minus {
  width: 20px;
  height: 20px;
}

/deep/ .van-stepper__input {
  width: 20px;
  height: 20px;
}

/deep/ .van-stepper__plus {
  width: 20px;
  height: 20px;
}

.van-button {
  width: 345px;
  height: 35px;
  font-size: 18px;
  line-height: 35px;
  margin: 10px auto;
}
</style>